
import store, { awaitStudentLoaded } from "@/store";
import { getLearningsOf } from "@/api/learning";
import { Vue } from "vue-class-component";
import dayjs from "dayjs";

export default class ReflectionLatest extends Vue {
  timerId = -1;
  counter = 0;
  async created() {
    const student = await awaitStudentLoaded(store);
    this.timerId = setInterval(async () => {
      const learnings = await getLearningsOf(student.ref);
      if (
        learnings?.[0] &&
        learnings[0].data &&
        !learnings[0].data.reflection &&
        dayjs().unix() - learnings[0].data.timestamp < 60 * 60 * 1
      ) {
        // 最新の learning ドキュメントが直前に作られたものであれば、ここで対象とするドキュメントである
        clearInterval(this.timerId);
        this.counter = 0;
        this.$router.push(`/learning/${learnings[0].ref.id}/reflection`);
      } else if (this.counter <= 5) {
        this.counter++;
      } else {
        // 一定回数試行したが振り返り未記入の learning ドキュメントが取得できなかった
        clearInterval(this.timerId);
        this.counter = 0;
        this.$router.push("/");
      }
    }, 5000);
  }
}
